import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../../../../../environments/environment';
import { ApiMethodService } from '../../../../tools/services/api/method-api/apiMethod.service';
import {
  EvChargerTransactionChartDto,
  EvChargerTransactionChartQuery,
  EvChargerTransactionTableDto,
  EvChargerTransactionTableQuery,
} from '../../../models/ev/ev-charger-list.model';

@Injectable({
  providedIn: 'root',
})
export class ApiEvChargerListService {
  private readonly baseUrl = environment.apiPrivateUrl;
  private readonly cookieService = inject(CookieService);
  private readonly apiMethodService = inject(ApiMethodService);

  getEvChargerTransactionForTable(query: EvChargerTransactionTableQuery): Observable<EvChargerTransactionTableDto> {
    const token = this.cookieService.get('token');
    const params: Record<string, string | number> = {
      siteId: query.siteId,
      userId: query.userId,
      startDate: query.startDate,
      endDate: query.endDate,
      page: query.page ?? 1,
      pageSize: query.pageSize ?? 20,
    };

    if (query.searchField) params['searchField'] = query.searchField;
    if (query.searchText) params['searchText'] = query.searchText;
    if (query.sortColumn) params['sortColumn'] = query.sortColumn;
    if (query.sortDirection) params['sortDirection'] = query.sortDirection;
    if (query.statusCodes) params['statusCodes'] = query.statusCodes;
    if (query.exitFilter) params['exitFilter'] = query.exitFilter;
    if (query.minPrice != null) params['minPrice'] = query.minPrice;

    return this.apiMethodService.request<EvChargerTransactionTableDto>(
      '/backoffice/getEvChargerTransactionForTable',
      'GET',
      this.baseUrl,
      {
        isConsoleLog: true,
        labelLog: 'getEvChargerTransactionForTable',
        token,
        headerOnly: false,
        params,
      }
    );
  }

  getEvChargerTransactionChart(query: EvChargerTransactionChartQuery): Observable<EvChargerTransactionChartDto> {
    const token = this.cookieService.get('token');
    return this.apiMethodService.request<EvChargerTransactionChartDto>(
      '/backoffice/getEvChargerTransactionChart',
      'GET',
      this.baseUrl,
      {
        isConsoleLog: false,
        labelLog: 'getEvChargerTransactionChart',
        token,
        headerOnly: false,
        params: {
          siteId: query.siteId,
          userId: query.userId,
          startDate: query.startDate,
          endDate: query.endDate,
        },
      }
    );
  }
}
